module.exports = __webpack_public_path__ + "img/bannertest2.51e46bf0.jpg";